// const BASE_API_URL = "http://54.185.32.148/api";

// export default BASE_API_URL;

// export const MEDIA_BASE_URL = "http://54.185.32.148/";



// const BASE_API_URL = "https://basketballinstructionstatenisland.com/api";


const BASE_API_URL = process.env.REACT_APP_SERVER;

export default BASE_API_URL;

export const MEDIA_BASE_URL = "https://basketballinstructionstatenisland.com";

export const STRIPE_PUBLISHABLE_KEY =process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;


// export const STRIPE_PUBLISHABLE_KEY = "pk_test_51T01S9LC4iLW1IhRbJanDSrRZJ0UAFlXbe7MFvvVNhfReAQbNbuctjjcuDVQAjMTVIJChemGaNzeRw4D54Vz0oA300wKh6XwY7"
